/* -----------------------------------------------------------------
Import Modules
----------------------------------------------------------------- */

// import { offset } from 'meteora';
import VisibilityController from 'scripts/marmalade/classes/visibility';

/* -----------------------------------------------------------------
Page Setup
----------------------------------------------------------------- */

// Find the nav on the page
const nav = document.querySelector('.js-blocks-navigation');
// Find all the links inside the nav
const links = [...nav.querySelectorAll('a')];
// A list of all the blocks on the page
const blocks = [];
// Find the top and bottom toggles
const toggles = {
  top: document.querySelector('.js-blocks-navigation--top'),
  bottom: document.querySelector('.js-blocks-navigation--bottom')
};

// Create a new VisibilityController
const Visibility = new VisibilityController();

// Loop through all the links
links.forEach(link => {
  // The link element has a href with a #ID of the block
  // First get just the ID from the href
  const ID = link.getAttribute('href').split('#')[1];
  // Find the block on the page
  const block = document.getElementById(ID);

  // If the block exists add it to the blocks array
  if (!block) return;

  // Add the block to the blocks array
  blocks.push(block);

  // When the link is clicked, scroll to the block
  link.addEventListener('click', e => {
    e.preventDefault();

    // Grab the current url
    let url = window.location.href;
    // Remove the hash from the url
    url = url.split('#')[0];
    // Add the hash to the url
    url += `#${ID}`;
    // Update the url without reloading the page
    window.history.replaceState({}, '', url);
    let offsetY = Meteora.offset(block).y;
    if (block.clientHeight < window.innerHeight) {
      // Adjust the offset to center the block in the window
      offsetY -= (window.innerHeight - block.clientHeight) / 2;
    } else {
      // Adjust the offset to be the top of the block - 200px for the nav
      offsetY -= 200;
    }

    // With a minimum of 0 and a maximum of the document height minus the window height, scroll to the block
    let y = Math.min(Math.max(offsetY, 0), document.documentElement.scrollHeight - window.innerHeight);
    ScrollController.scrollTo(y, 2000);
  });
});

// Observe all the blocks with the visibility controller
blocks.forEach(block => Visibility.observe(block));
Visibility.on('change', active => {
  // Loop through all the links
  links.forEach(link => {
    // If the link href matches the active block ID, add the active class, otherwise remove it
    link.classList.toggle('active', link.href.indexOf(`#${active.id}`) != -1);
  });
});
Object.keys(toggles).forEach(key => {
  const toggle = toggles[key];

  // Set up an intersection observer to watch the top and bottom toggles
  const Observer = new IntersectionObserver(entries => {
    // If the toggle is intersecting with the viewport, add the active class, otherwise remove it
    nav.classList.toggle(key + '-toggle-visible', entries[0].isIntersecting);
  });

  // Observe the toggle
  Observer.observe(toggle);
});